export const getConfectioneryDetail = (score_id, products) => {
  const confectionery = products.find(
    (product) => `${product.score_id}` === `${score_id}`
  );
  if (confectionery) {
    return confectionery;
  }

  return null;
};

export const formatCurrency = (value) => {
  return new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 0,
  }).format(value);
};

export const getTotalsRecipe = (recipe = []) => {
  let totalGeneral = 0;
  let totalOthers = 0;

  if (!recipe || !recipe.length) {
    return {
      totalOthers,
    };
  }
  recipe.forEach((item) => {
    if (item.Tipo === "P") {
      const prices = item.Precios[0];
      totalOthers = totalOthers += prices.OtroPago;
      totalGeneral = totalGeneral += prices.General;
    } else {
      item?.Receta.forEach((product) => {
        const prices = product.Precios[0];
        totalOthers = totalOthers += prices.OtroPago;
        totalGeneral = totalGeneral += prices.General;
      });
    }
  });

  return {
    totalOthers,
    totalGeneral,
    saving: totalGeneral - totalOthers,
  };
};

export const getTotalCombos = (combos) => {
  let totalGeneral = 0;
  let totalOthers = 0;

  if (!combos || !combos.length) {
    return {
      totalGeneral,
      totalOthers,
      saving: 0,
    };
  }

  combos.forEach((combo) => {
    let totals = getTotalsRecipe(combo.Receta);
    totals = {
      totalGeneral: totals.totalGeneral * combo.Cantidad,
      totalOthers: totals.totalOthers * combo.Cantidad,
    };
    totalGeneral += totals.totalGeneral;
    totalOthers += totals.totalOthers;
  });

  return {
    totalGeneral,
    totalOthers,
    saving: totalGeneral - totalOthers,
  };
};

export const getCombosToPay = (
  selectedCombos,
  productsApi,
  isVizionario = false
) => {
  const price = isVizionario ? 2 : 1;
  const product = [];
  const productsDetail = [];
  let description = "";

  selectedCombos.forEach((item, index) => {
    const firstDesctiption = getConfectioneryDetail(item.Codigo, productsApi);
    const firstName = firstDesctiption
      ? firstDesctiption.name
      : item.Descripcion;
    description += `${index > 0 ? ", " : ""}${item.Cantidad} ${firstName}`;
    for (let i = 0; i < item.Cantidad; i++) {
      let products = [];
      let productsBepass = [];

      item.Receta.forEach((recipe) => {
        let data = {
          Codigo: recipe.Codigo,
          Descripcion: recipe.Descripcion,
          Tipo: recipe.Tipo,
          Cantidad: recipe.Cantidad,
        };
        if (recipe.Tipo === "A") {
          let products = [];
          recipe.Receta.forEach((product) => {
            let data = {
              Cantidad: product.Cantidad,
              Codigo: product.Codigo,
              Descripcion: product.Descripcion,
              Tipo: product.Tipo,
            };
            let productDescription = getConfectioneryDetail(
              product.Codigo,
              productsApi
            );

            products.push(data);
            productsBepass.push({
              ...data,
              Categoria: productDescription?.category_name ?? "",
              Descripcion: productDescription?.name ?? "" ,
            });
          });
          data.Receta = products;
        } else {
          let productDescription = getConfectioneryDetail(
            recipe.Codigo,
            productsApi
          );

          productsBepass.push({
            ...data,
            Categoria: productDescription?.category_name ?? "",
            Descripcion: productDescription?.name ?? "",
          });
        }

        products.push(data);
      });

      let data = {
        Codigo: item.Codigo,
        Descripcion: item.Descripcion,
        Tipo: item.Tipo,
        Precio: price,
        Receta: products,
      };

      let productDescription = getConfectioneryDetail(item.Codigo, productsApi);

      product.push(data);
      productsDetail.push({
        ...data,
        Categoria: productDescription?.category_name ?? "",
        Descripcion: productDescription?.name ?? "",
        Receta: productsBepass,
      });
    }
  });

  return { product, productsDetail, description };
};
